import { render, staticRenderFns } from "./processManual.vue?vue&type=template&id=ff039f0c"
import script from "./processManual.vue?vue&type=script&lang=js"
export * from "./processManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff039f0c')) {
      api.createRecord('ff039f0c', component.options)
    } else {
      api.reload('ff039f0c', component.options)
    }
    module.hot.accept("./processManual.vue?vue&type=template&id=ff039f0c", function () {
      api.rerender('ff039f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/pcd/processManual.vue"
export default component.exports